/**
 * useServerDirectory — de accountlijst van de server, één keer opgehaald.
 *
 * WAAROM DIT UIT HET PANEEL IS GEHAALD
 *
 * Eerst haalde het meldingspaneel de lijst zelf op. Dat betekende dat de
 * gegevens alleen bestonden zolang dat paneel in beeld was — en de tabel, die
 * de eigenlijke vraag beantwoordt ("wie zit er in het systeem?"), er niet bij
 * kon. Een beheerder zag daardoor pas iets over serveraccounts nádat hij op een
 * lokaal account had geklikt. Dat is de verkeerde volgorde: de lijst is het
 * hoofdding, de melding een voetnoot.
 *
 * Door het ophalen hier te doen, kunnen zowel de tabel als het paneel dezelfde
 * gegevens gebruiken zonder twee keer te bevragen.
 */

import { useCallback, useEffect, useState } from 'react';
import { listAccounts, type DirectoryAccount } from '../../../../data/supabase/adminDirectory';
export interface ServerDirectoryState {
  accounts: DirectoryAccount[];
  loading: boolean;
  error: string | null;
  loaded: boolean;
  refresh: () => Promise<void>;
}
export function useServerDirectory(): ServerDirectoryState {
  const [accounts, setAccounts] = useState<DirectoryAccount[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [loaded, setLoaded] = useState(false);
  const refresh = useCallback(async () => {
    setLoading(true);
    setError(null);
    const res = await listAccounts();
    setLoading(false);
    setLoaded(true);
    if (!res.ok) {
      setError(res.message ?? 'Ophalen mislukt.');
      return;
    }
    setAccounts(res.accounts);
  }, []);
  useEffect(() => {
    void refresh();
    // Eenmalig. Bewust geen interval: deze lijst verandert traag, en een
    // pollende query over alle profielen is een dure gewoonte om per ongeluk in
    // te bouwen. Vernieuwen blijft handmatig mogelijk.
  }, [refresh]);
  return {
    accounts,
    loading,
    error,
    loaded,
    refresh
  };
}